import { Controller, FieldValues, UseControllerProps, Path } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { FormControlLabel } from '@mui/material';

import { DateInputFormat } from '@shared/helpers/date';


type Props<T extends FieldValues> = Pick<UseControllerProps<T>, 'rules'> & {
  name: Path<T>
  label: string
  maxDate?: Date
  minDate?: Date
  onChange?: (value: Date | null) => void
}

export function DateField <T extends FieldValues>({ name, label, rules, maxDate, minDate, onChange }: Props<T>) {
  return (
    <FormControlLabel
      labelPlacement="top"
      sx={{
        alignItems: 'flex-start',
        color: '#263238',
        m: 0,
        width: '100%',
        '.MuiFormControlLabel-label': {
          fontSize: 14,
          fontWeight: 500,
          mb: 1,
        },
      }}
      slotProps={{
        typography: {
          fontSize: 12,
          fontWeight: 400,
        },
      }}
      control={
        <Controller
          name={name}
          rules={rules}
          render={({ field: { ref, ...field }, fieldState }) => (
            <DatePicker
              {...field}
              inputRef={ref}
              disableFuture
              openTo="year"
              views={['year', 'month', 'day']}
              format={DateInputFormat}
              maxDate={maxDate}
              minDate={minDate}
              onChange={(date) => {
                field.onChange(date);
                onChange?.(date);
              }}
              slotProps={{
                openPickerButton: {
                  color: 'inherit',
                },
                textField: {
                  fullWidth: true,
                  size: 'small',
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message,
                  sx: {
                    fieldset: {
                      borderColor: '#e2e8f0',
                      borderRadius: '10px',
                    },
                  },
                },
                popper: {
                  sx: {
                    '.MuiPickersArrowSwitcher-button': {
                      color: 'primary.main',
                      opacity: 1,
                    },
                  },
                },
              }}
            />
          )}
        />
      }
      label={label}
    />
  );
}
